import {
  Button,
  Drawer,
  Modal,
  TagPicker,
  SelectPicker,
  DatePicker,

} from "rsuite";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useEffect } from "react";
import "rsuite/dist/rsuite.min.css";
import { useDispatch, useSelector } from "react-redux";
import "moment/locale/pt-br";
import { Icon } from "@rsuite/icons";
import {
  allHorarios,
  allServicios,
  updateHorario,
  filterHorarios,
  addHorario,
  resetHorario,
  removeHorario,
} from "../../store/modules/horario/actions";

moment.locale("pt-br");
const localizer = momentLocalizer(moment);

const Horarios = () => {
  const dispatch = useDispatch();
  const {
    horarios,
    horario,
    components,
    form,
    behavior,
    servicos,
    colaboradores,
  } = useSelector((state) => state.horario);

  const save = () => {
    dispatch(addHorario());
  };

  const diasSemanaData = [
    new Date(2021, 3, 11, 0, 0, 0, 0),
    new Date(2021, 3, 12, 0, 0, 0, 0),
    new Date(2021, 3, 13, 0, 0, 0, 0),
    new Date(2021, 3, 14, 0, 0, 0, 0),
    new Date(2021, 3, 15, 0, 0, 0, 0),
    new Date(2021, 3, 16, 0, 0, 0, 0),
    new Date(2021, 3, 17, 0, 0, 0, 0),
  ];

  const diasDaSemana = [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sabado",
  ];

  const formatEvents = horarios.map((horario, index) =>
    horario
      .map((horario, index) =>
        horario.dias.map((dia, i) => ({
          resource: horario,
          title: `${horario.especialidades.length} espec. e ${horario.colaboradores.length} colab.`,
          start: new Date(
            diasSemanaData[dia].setHours(
              parseInt(moment(horario.inicio).format("HH")),
              parseInt(moment(horario.inicio).format("mm"))
            )
          ),
          end: new Date(
            diasSemanaData[dia].setHours(
              parseInt(moment(horario.fim).format("HH")),
              parseInt(moment(horario.fim).format("mm"))
            )
          ),
        }))
      )
      .flat()
  );

  const setComponent = (component, state) => {
    dispatch(
      updateHorario({
        components: { ...components, [component]: state },
      })
    );
  };

  const setHorario = (key, value) => {
    dispatch(
      updateHorario({
        horario: { ...horario, [key]: value },
      })
    );
  };

  const remove = () => {
    
    dispatch(removeHorario());
  };


  useEffect(() => {
    dispatch(allHorarios());
    dispatch(allServicios());
  }, []);

  useEffect(() => {
    dispatch(filterHorarios());
  }, [horario.especialidades]);

  return (
    <div className="col p-5 h-100 overflow-auto">
      <Drawer
        open={components.drawer}
        size="sm"
        onClose={() => setComponent("drawer", false)}
      >
        <Drawer.Body>
          <h3>{behavior === "create" ? "Criar Novo" : "Atualizar"} Horario </h3>

          <div className="row mt-3">
            <b>Dias da semana</b>
            <TagPicker
              size="lg"
              data={diasDaSemana.map((label, value) => ({ label, value }))}
              disabled={form.disabled && behavior === "create"}
              value={horario.dias}
              onChange={(value) => {
                setHorario("dias", value);
              }}
            />
          </div>
          <div className="row mt-3">
            <DatePicker
              block
              format="HH:mm"
              hideMinutes={(min) => ![0, 30].includes(min)}
              value={horario.start}
              onChange={(e) => {
                setHorario("inicio", e);
              }}
            />
          </div>
          <div className="row mt-3">
            <DatePicker
              block
              format="HH:mm"
              hideMinutes={(min) => ![0, 30].includes(min)}
              value={horario.end}
              onChange={(e) => setHorario("fim", e)}
            />
          </div>
          <div className="row mt-3">
            <b>Especialidade</b>
            <TagPicker
              size="lg"
              data={servicos}
              disabled={form.disabled && behavior === "create"}
              value={horario.especialidades}
              onChange={(especialidade) => {
                setHorario("especialidades", especialidade);
              }}
            />
          </div>
          <div className="row mt-3">
            <b>Colaborador</b>
            <TagPicker
              size="lg"
              data={colaboradores}
              value={horario.colaboradores}
              onChange={(especialidade) => {
                setHorario("especialidades", especialidade);
              }}
            />
          </div>

          <Button
            block
            appearance="primary"
            className=" mt-3"
            color={behavior === "create" ? "green" : "blue"}
            size="lg"
            loading={form.saving}
            onClick={() => {
              save();
            }}
          >
            {behavior === "create" ? "salvar" : "Atualizar"} Horario
          </Button>
          {behavior === "update" && (
            <Button
              appearance="primary"
              loading={form.saving}
              color="red"
              size="lg"
              block
              className="mt-1"
              onClick={() => {
               
                setComponent("confirmDelete", true);
              }}
            >
              {" "}
              Remover Horario
            </Button>
          )}
        </Drawer.Body>
      </Drawer>
         <Modal
        open={components.confirmDelete}
        onHide={() => setComponent("confirmDelete", false)}
        size="xs"
      >
        <Modal.Body>
          <Icon
            icon="remind"
            style={{
              color: "#ffb300",
              fontSize: 24,
            }}
          />
          {"   "}Tem certeza que deseja excluir? Essa ação será inrreversivel!
        </Modal.Body>
        <Modal.Footer>
          <Button loading={form.saving} onClick={() => remove()}    appearance="primary"color="red">
            Sim, tenho certeza!
          </Button>
          <Button
            loading={form.saving}
            onClick={() => setComponent("confirmDelete", false)}
            appearance="primary"
            color="green"
          >
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="row">
        <div className="col-12">
          <h2 className="mb-4 mt-0">Agendamentos</h2>
          <div className="w-100 d-flex justify-content-between">
            <h2 className="mb-4 mt-0">Horarios de atendimento </h2>

            <div>
              <button className="btn btn-primary btn-sm" onClick={() => {
               
                  dispatch(resetHorario())
                  dispatch(
                    
                    updateHorario({
                      behavior: "create",
                      
                    })
                  );
                  setComponent("drawer", true);
                
              }}>
                <span className="mdi mdi-plus"> Novo Horario </span>
              </button>
            </div>
          </div>
          <Calendar
            onSelectEvent={(e) => {
              dispatch(
                updateHorario({
                  behavior: "update",
                })
              );
              dispatch(updateHorario({ horario: e.resource }));

              setComponent("drawer", true);
            }}
            localizer={localizer}
            toolbar={false}
            formats={{
              dateFormat: "dd",
              dayFormat: (date, culture, localizer) =>
                localizer.format(date, "dddd", culture),
            }}
            popup
            selectable
            view="week"
            events={formatEvents[0]}
            date={diasSemanaData[moment().day()]}
            style={{ height: 600 }}
            onSelectSlot={(slotInfo)=> {
              const{ start, end} = slotInfo
            
            dispatch(updateHorario(              
              {
                behavior:'create',
                horario:{
                  ...horario,
                  dias:[moment(start).day()],
                  inicio: start,
                  fim:end
                }
              }
            ))
            setComponent("drawer", true)
            
            
            }
            
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Horarios;
